module.exports = "<div class=\"header row\">\n    <h1 class=\"large-2\"><img src=\"" + require("../../../../../assets/logo.png") + "\" (click)=\"toHomePage()\"></h1>\n    <div class=\"header-info large-10\">\n        <div class=\"component-name\">\n            <h3>{{headerName}}</h3>\n        </div>\n        <ul *ngIf=\"sidebarStatus\">\n            <li><a (click)=\"deleteSession()\">Logout</a></li>\n        </ul>\n    </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/modules/core/components/admin-header/AdminHeaderComponent.html
// module id = 97
// module chunks = 0